module.exports = __webpack_public_path__ + "static/img/Eyres_Brooks_classification_of_scapular_coracoid_process.3d7dc5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/Eyres_Brooks_classification_of_scapular_coracoid_process.png
// module id = iYlh
// module chunks = 2